/** Identifiant du message d'erreur d'un champ, cible de son `aria-describedby`. */
export function errorId(fieldId: string): string {
  return `${fieldId}-error`
}

/**
 * Relie un champ à son erreur (RGAA 11.10) dans les formulaires qui ne passent
 * pas par `Form`/`FormControl` : le champ se dit invalide et cite le message.
 */
export function errorAria(fieldId: string, error: unknown): { 'aria-invalid': boolean, 'aria-describedby'?: string } {
  return error ? { 'aria-invalid': true, 'aria-describedby': errorId(fieldId) } : { 'aria-invalid': false }
}
